import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _round from 'lodash/round';
import CollapseWrapper from '../../../../components/Global/CollapseWrapper';
import { withStyles } from '@material-ui/core/styles';
import combineStyles from '../../../../utils/combineStyles';
import TypographyStyles from '../../../../styles/typography';
import LayoutStyles from '../../../../styles/layout';
import SpacingStyles from '../../../../styles/helpers/spacing';
import UnitStyles from './__styles__/Unit.styles';
import Product from './Product';
import Button from '@material-ui/core/Button';
import ButtonStyles from '../../../../styles/button';
import TextFieldInput from '../../../../components/Global/Inputs/TextField';
import { AppContext } from '../../../../AppProvider';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { FastField, FieldArray } from 'formik';
import ConfirmDialogModal from '../../../Global/Modals/ConfirmDialog';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import CheckboxInput from '../../../../components/Global/Inputs/Checkbox';
import {
  UNIT_ABBREVIATIONS,
  CURRENCY_SYMBOL
} from '../../../../constants/constants';
import OutlinedSelectInput from '../../../../components/Global/Inputs/OutlinedSelect';
import { DATATYPES } from './../../../../constants/constants';
import {
  calcUnitTotal,
  calcUnitDensity,
  calcUnitVolume,
  calcClass
} from './helpers';
import GridItem from './../../../Global/GridItem';

export class Unit extends Component {
  static propTypes = {
    handleChange: PropTypes.func.isRequired,
    handleValidateField: PropTypes.func.isRequired,
    unitNumber: PropTypes.number.isRequired,
    unit: PropTypes.shape({}),
    setFieldValue: PropTypes.func.isRequired,
    showProduct: PropTypes.bool,
    isQuickRate: PropTypes.bool,
    contacts: PropTypes.array
  };

  constructor(props, context) {
    super(props, context);
    const {
      defaultWeightUnit,
      defaultCurrency,
      defaultDensityUnit,
      defaultVolumeUnit,
      defaultDimensionUnit
    } = this.context.globalProps.orgInfo.config;

    const defaultProduct = {
      id: null,
      name: '',
      freightClassId: '',
      totalWeight: 0,
      weightUnit: UNIT_ABBREVIATIONS[defaultWeightUnit],
      totalValue: 0,
      quantity: 1,
      isHazMat: false,
      currency: CURRENCY_SYMBOL[defaultCurrency],
      product: {
        description: '',
        freightInfo: {
          nmfcItemCode: '',
          nmfcSubCode: ''
        },
        weightInfo: { weight: 0 },
        valueInfo: { value: null }
      }
    };

    this.state = {
      openConfirmDeleteNotificationModal: false,
      defaultWeightUnit,
      defaultCurrency,
      defaultDensityUnit,
      defaultVolumeUnit,
      defaultDimensionUnit,
      defaultProduct,
      unitField: `handlingUnits[${this.props.unitNumber}]`
    };
  }
  _handleOpenConfirmDeleteNotificationModal = () => {
    this.setState({ openConfirmDeleteNotificationModal: true });
  };

  _handleCloseConfirmDeleteNotificationModal = () => {
    this.setState({ openConfirmDeleteNotificationModal: false });
  };

  _handleRemoveUnit = () => {
    this.props.onRemove();
    this._handleCloseConfirmDeleteNotificationModal();
  };
  componentDidUpdate() {
    const { unit } = this.props;
    const total = calcUnitTotal(unit);
    const density = calcUnitDensity(unit).toFixed(1);
    const volume = calcUnitVolume(unit);
    if (unit.density !== density) {
      this._updateUnitField('density', density);
      this._updateUnitField('freightInfo.freightClassId', calcClass(density));
    }

    if (unit.volume !== volume) {
      this._updateUnitField('volume', volume);
    }

    if (unit.totalValue !== total) {
      this._updateUnitField('totalValue', total);
    }
  }
  componentDidMount() {
    const { unit } = this.props;
    this._updateUnitField('totalValue', calcUnitTotal(unit));
  }
  _updateUnitField = (field, value) => {
    const { setFieldValue } = this.props;
    const { unitField } = this.state;
    setFieldValue(`${unitField}.${field}`, value);
  };

  render() {
    const {
      classes,
      unit,
      handleChange,
      handleValidateField,
      t,
      unitNumber,
      setFieldValue,
      showProduct = true,
      isQuickRate = false,
      contacts
    } = this.props;

    const {
      freightClasses,
      packageTypes
    } = this.context.globalProps.referenceData;
    const {
      defaultProduct,
      defaultWeightUnit,
      defaultCurrency,
      defaultDensityUnit,
      defaultVolumeUnit,
      defaultDimensionUnit,
      unitField
    } = this.state;

    return (
      <Fragment>
        <CollapseWrapper
          expanded={true}
          classes={{
            root: classnames(classes.root),
            body: classes.panelBody,
            expandButton: classes.buttonColor
          }}
          header={
            <div className={classes.titleWrapper}>
              <h2 className={classes.headline7}>
                {t('UNIT')} {unitNumber + 1}
              </h2>
              {unitNumber + 1 > 1 && (
                <Button
                  color="primary"
                  className={classnames(classes.linkButton, classes.unitAction)}
                  classes={{
                    label: classnames(classes.body2, classes.unitActionLabel)
                  }}
                  onClick={this._handleOpenConfirmDeleteNotificationModal}
                >
                  {t('Remove')}
                </Button>
              )}
            </div>
          }
          body={
            <FieldArray
              name={`${unitField}.shipmentItems`}
              validateOnChange={false}
              render={arrayHelpers => (
                <div className={classes.contents}>
                  {showProduct && (
                    <Fragment>
                      {unit.shipmentItems.map((item, index) => {
                        return (
                          <Product
                            product={item}
                            handleChange={handleChange}
                            handleValidateField={handleValidateField}
                            key={index}
                            productNumber={index}
                            unitNumber={unitNumber}
                            onRemove={() => arrayHelpers.remove(index)}
                            setFieldValue={setFieldValue}
                            contacts={contacts}
                          />
                        );
                      })}
                      <Button
                        variant="outlined"
                        color="primary"
                        className={classnames(
                          classes.outlinedButton,
                          classes.addUnitButton,
                          classes.noMarginBottom
                        )}
                        classes={{ label: classes.buttonLabel }}
                        onClick={() => {
                          arrayHelpers.push(defaultProduct);
                        }}
                      >
                        {t('Add a Product')}
                      </Button>
                      <div
                        className={classnames(
                          classes.row,
                          classes.subtitle3,
                          classes.unitDescription
                        )}
                      >
                        {t('Unit Description')}
                      </div>
                    </Fragment>
                  )}
                  <Grid container spacing={16}>
                    <GridItem lg={2}>
                      <FastField
                        value={_get(unit, 'dimensionInfo.length', '')}
                        name={`${unitField}.dimensionInfo.length`}
                        label={t('L')}
                        onChange={handleChange}
                        component={TextFieldInput}
                        validateField={handleValidateField}
                        endAdornment={UNIT_ABBREVIATIONS[defaultDimensionUnit]}
                      />
                    </GridItem>
                    <GridItem lg={2}>
                      <FastField
                        value={_get(unit, 'dimensionInfo.width', '')}
                        name={`${unitField}.dimensionInfo.width`}
                        label={t('W')}
                        onChange={handleChange}
                        validateField={handleValidateField}
                        component={TextFieldInput}
                        endAdornment={UNIT_ABBREVIATIONS[defaultDimensionUnit]}
                      />
                    </GridItem>
                    <GridItem lg={2}>
                      <FastField
                        value={_get(unit, 'dimensionInfo.height', '')}
                        name={`${unitField}.dimensionInfo.height`}
                        label={t('H')}
                        onChange={handleChange}
                        validateField={handleValidateField}
                        component={TextFieldInput}
                        endAdornment={UNIT_ABBREVIATIONS[defaultDimensionUnit]}
                      />
                    </GridItem>
                    <GridItem lg={3}>
                      <FastField
                        value={_get(unit, 'actualWeightInfo.weight', '')}
                        name={`${unitField}.actualWeightInfo.weight`}
                        label={t('Unit Weight')}
                        onChange={handleChange}
                        validateField={handleValidateField}
                        component={TextFieldInput}
                        datatype={DATATYPES.number}
                        endAdornment={UNIT_ABBREVIATIONS[defaultWeightUnit]}
                      />
                    </GridItem>
                    <GridItem lg={3}>
                      <FastField
                        name={`${unitField}.freightInfo.freightClassId`}
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return (
                            <OutlinedSelectInput
                              value={_get(
                                unit,
                                'freightInfo.freightClassId',
                                null
                              )}
                              field={field}
                              form={form}
                              label={t('Class')}
                              options={freightClasses}
                              validateField={handleValidateField}
                              multiple={false}
                            />
                          );
                        }}
                      />
                    </GridItem>
                    <GridItem lg={3}>
                      <FastField
                        value={unit.unitCount}
                        name={`${unitField}.unitCount`}
                        label={t('Qty')}
                        type="number"
                        min={1}
                        onChange={handleChange}
                        validateField={handleValidateField}
                        component={TextFieldInput}
                      />
                    </GridItem>
                    <GridItem lg={3}>
                      <FastField
                        name={`${unitField}.packageTypeId`}
                        onChange={handleChange}
                        render={({ field, form }) => {
                          return (
                            <OutlinedSelectInput
                              value={unit.packageTypeId}
                              field={field}
                              form={form}
                              label={t('Package Type')}
                              options={packageTypes}
                              validateField={handleValidateField}
                              multiple={false}
                            />
                          );
                        }}
                      />
                    </GridItem>
                    <GridItem lg={3}>
                      <div className={classes.checkboxContainer}>
                        <FastField
                          name={`${unitField}.stackable`}
                          onChange={handleChange}
                          render={({ field, form }) => (
                            <CheckboxInput
                              label={t('Stackable')}
                              field={field}
                              form={form}
                              value={unit.stackable}
                              classes={{
                                root: classnames(
                                  classes.noMarginTop,
                                  classes.body1
                                )
                              }}
                            />
                          )}
                        />
                      </div>
                    </GridItem>
                    <GridItem lg={3}>
                      <ol
                        className={classnames(
                          classes.unitCalculationsContainer,
                          classes.body2
                        )}
                      >
                        <li>
                          {t('Volume')}:{' '}
                          {unit.volume ? _round(unit.volume, 2) : '--'}
                          {unit.volume
                            ? ` ${UNIT_ABBREVIATIONS[defaultVolumeUnit]}`
                            : ''}
                          {unit.volume ? <sup>3</sup> : ''}
                        </li>
                        <li>
                          {t('Density')}:{' '}
                          {unit.density ? _round(unit.density, 2) : '--'}
                          {unit.density
                            ? ` ${UNIT_ABBREVIATIONS[defaultDensityUnit]}`
                            : ''}
                          {unit.density ? <sup>3</sup> : ''}
                        </li>
                        {!isQuickRate && (
                          <li>
                            {t('Total Value')}:{' '}
                            {CURRENCY_SYMBOL[defaultCurrency]}
                            {unit.totalValue}
                          </li>
                        )}
                      </ol>
                    </GridItem>
                  </Grid>
                </div>
              )}
            />
          }
        />
        <ConfirmDialogModal
          open={this.state.openConfirmDeleteNotificationModal}
          title={t('Are you sure you want to remove this Unit?')}
          message={`${t('Unit')} ${unitNumber + 1} ${t(
            'will no longer available.'
          )}`}
          confirmLabel={t('Delete')}
          onClose={this._handleCloseConfirmDeleteNotificationModal}
          onConfirm={this._handleRemoveUnit}
        />
      </Fragment>
    );
  }
}

Unit.contextType = AppContext;
const translateUnit = withNamespaces()(Unit);
export default withStyles(
  combineStyles(
    TypographyStyles,
    LayoutStyles,
    SpacingStyles,
    ButtonStyles,
    UnitStyles
  )
)(translateUnit);
